import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "confirmation-holder" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ConfirmationOverlay = _resolveComponent("ConfirmationOverlay")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.showConfirmation)
      ? (_openBlock(), _createBlock(_component_ConfirmationOverlay, {
          key: 0,
          acceptTheme: "primary",
          rejectTheme: "return",
          titleText: _ctx.titleText,
          acceptText: "Confirmed, DOT and safe.",
          rejectText: "No",
          onAccept: _ctx.acceptPrompt,
          onReject: _ctx.rejectPrompt,
          acceptDisabled: _ctx.dotInspectionExpired,
          disabled: _ctx.submitting
        }, null, 8, ["titleText", "onAccept", "onReject", "acceptDisabled", "disabled"]))
      : _createCommentVNode("", true)
  ]))
}